import {SearchItem, SearchResultDto} from "../search/search-table.dto.res";
import {VehicleTireDto} from "./vehicle-tire.dto";

export class SearchVehicleTireRes extends SearchResultDto {

  public override readonly items: SearchVehicleTireItem[] = [];

  constructor(init?: Partial<SearchVehicleTireRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchVehicleTireItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchVehicleTireItem extends VehicleTireDto implements SearchItem {

  public override readonly id!: string;
  public readonly contactId!: string;

  constructor(init?: Partial<SearchVehicleTireItem>) {
    super(init);
    Object.assign(this, init);
  }
}
